import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/motion/reveal'
import { ScrubWords } from '@/components/motion/scrub-words'
import { ToneSection } from '@/components/generals/tone'

export const Manifesto: FC = (): ReactNode => {
    return (
        <ToneSection tone='ink' id='approach' className='px-5 py-32 md:px-8 lg:px-12 lg:py-52'>
            <div className='grid gap-12 lg:grid-cols-12'>
                <Reveal className='flex flex-col gap-5 lg:col-span-3'>
                    <span className='t-label text-tone-muted'>
                        (01) Approach
                    </span>
                    <span className='max-w-[15rem] text-sm leading-relaxed text-tone-muted'>
                        Unlike one-size-fits-all fraud tools: one dedicated model per merchant.
                    </span>
                </Reveal>

                <ScrubWords
                    className='font-heading text-[clamp(1.85rem,3.9vw,3.75rem)] font-medium leading-[1.08] tracking-[-0.025em] lg:col-span-9'
                    emphasisClassName='font-serif font-normal italic tracking-normal text-tone-accent'
                    segments={[
                        { text: 'nSure.ai turns fraud prevention into a profit driver for crypto exchanges and high-risk digital merchants. Unlike one-size-fits-all fraud tools, we build a dedicated AI model for each merchant trained on their own transaction data, focusing on behavioral patterns,' },
                        { text: 'the only signal fraudsters can’t fake.', emphasis: true }
                    ]}
                />
            </div>
        </ToneSection>
    )
}
